<template>
  <div class="intro">
    <div class="banner">
      <div class="pic-wrap">
        <img src="../../../assets/img/index/intro-banner.png" alt="" />
        <div class="dot dot-top-left">
          <div class="line h"></div>
          <div class="line s"></div>
        </div>
        <div class="dot dot-top-right">
          <div class="line h"></div>
          <div class="line s"></div>
        </div>
        <div class="dot dot-bom-left">
          <div class="line"></div>
        </div>
        <div class="dot dot-bom-right">
          <div class="line"></div>
        </div>
      </div>
      <div class="intro-list top-left animate__animated animate__fadeInLeftBig animate__delay-1s">
        <div class="tit">AI智能</div>
        <div class="des">科技赋能 海量处理 快捷方便</div>
        <div class="des">AI予力 塑造新动能</div>
        <div class="des">推动项目快速开发、服务创新、项目升级</div>
        <div class="des">AI赋能 降低成本 提高效率</div>
      </div>
      <div class="intro-list top-right animate__animated animate__fadeInRightBig animate__delay-4s">
        <div class="tit">区块链</div>
        <div class="des">科“点面相接 层层互通“</div>
        <div class="des"> “环环相扣的链式防护 层层加密的高新技术”</div>
      </div>
      <div class="intro-list bottom-left animate__animated animate__fadeInUpBig animate__delay-2s">
        <div class="tit">大数据风控</div>
        <div class="des">运用大数据构建模型，进行风险控制和风险提示</div>
        <div class="des">对多维度、大量数据的智能处理</div>
        <div class="des">批量标准化的执行流程，更能贴合信息</div>
        <div class="des">发展时代风控业务的发展要求</div>
      </div>
      <div class="intro-list bottom-right animate__animated animate__fadeInUpBig animate__delay-3s">
        <div class="tit">云计算</div>
        <div class="des">分布式计算，解决任务分发</div>
        <div class="des">并进行计算结果的合并在短时间内</div>
        <div class="des">完成对数以万计的数据处理</div>
        <div class="des">从而达到强大的网络服务通过互联网为用户</div>
        <div class="des">提供计算能力、存储、数据库等资源</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    jupm(){

    }
  }
}
</script>
<style lang="less" scoped>
@keyframes myshow{
  to { visibility: visible; }
}
.intro{
  width:100vw;
  background: #FAFAFC;
  overflow: hidden;
  .banner{
    max-width: 846px;
    margin:0 auto;
    position: relative;
    padding:5vh 0;
    img{
      width:100%;
      display: block;
    }
    .intro-list{
      position: absolute;
      .tit{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 21px;
        color: #222630;
        padding-bottom:8px;
      }
      .des{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 17px;
        color: #666666;
        max-width:240px;
      }
    }
    .top-left{
      top:6vh;
      left:-18vw;
    }
    .top-right{
      top:6vh;
      right:-18vw;
      text-align: right;
    }
    .bottom-left{
      bottom:7vh;
      left:-18vw;
    }
    .bottom-right{
      bottom:10vh;
      right:-18vw;
      text-align: right;
    }
    .pic-wrap{
      position: relative;
    }
    .dot{
      width:24px;
      height:24px;
      background:url(../../../assets/img/index/dot.png) no-repeat 0 0;
      position: absolute;
    }
    .dot-top-left{
      top:180px;
      left:68px;
      animation: myshow 0s 2.15s forwards;
      visibility: hidden;
      .line{
        border-top:1px solid #1694FB;
        position: absolute;
      }
      .h{
        left:calc(-10vw + 11px);
        top:-10vh;
        width:10vw;
        animation: myshow 0s 2s forwards;
        visibility: hidden;
      }
      .s{
        left: 11px;
        top:-10vh;
        width:1px;
        height:10vh;
        background:#1694FB;
        animation: myshow 0s 2.1s forwards;
        visibility: hidden;
      }
    }
    .dot-top-right{
      top:180px;
      right:68px;
      animation: myshow 0s 3.8s forwards;
      visibility: hidden;
      .line{
        border-top:1px solid #1694FB;
        position: absolute;
      }
      .h{
        right:calc(-10vw + 11px);
        top:-10vh;
        width:10vw;
        animation: myshow 0s 4s forwards;
        visibility: hidden;
      }
      .s{
        right: 11px;
        top:-10vh;
        width:1px;
        height:10vh;
        background:#1694FB;
        animation: myshow 0s 3.9s forwards;
        visibility: hidden;
      }
    }
    .dot-bom-left{
      bottom:38px;
      left:68px;
      animation: myshow 0s 3s forwards;
      visibility: hidden;
      .line{
        border-top:1px solid #1694FB;
        position: absolute;
        left:-10vw;
        top:11px;
        width:10vw;
        animation: myshow 0s 2.9s forwards;
        visibility: hidden;
      }
    }
    .dot-bom-right{
      bottom:100px;
      right:68px;
      animation: myshow 0s 3.2s forwards;
      visibility: hidden;
      .line{
        border-top:1px solid #1694FB;
        position: absolute;
        right:-10vw;
        top:11px;
        width:10vw;
        animation: myshow 0s 3.1s forwards;
        visibility: hidden;
      }
    }
  }
}
</style>
